import React, { useContext } from 'react'
import styled from 'styled-components'
import { FileContext } from '../../context/files';
const FooterEl = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    bottom: 0;
    z-index: 9;
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: center;
    background-color: white;
    box-shadow: 0 0 5px #2a2a2abf;
    font-family: Poppins-Medium;

    @media screen and (max-width:920px){
        
        display: none;
        
    }


`
const ContainerBox = styled.div`
    margin-top: 0.5rem;
    height: 90px;
    width: 100%;
    overflow-y: auto;
`
const Box = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 0.4rem;


`

const Footer = () => {

    const { userSelectFiles } = useContext(FileContext)

    return (

        <FooterEl className='animate__animated animate__fadeInDown'>
            <ContainerBox>
                {userSelectFiles?.map(item => (
                    <Box className='animate__animated animate__fadeInDown'>
                        <b>{item.sku}</b> - Revisão {item.revision}
                        
                    </Box>
                ))}
                
            </ContainerBox>
        </FooterEl>

    )
}

export default Footer